// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3nxCQ","rootSmall":"AddTileButton_rootSmall__29rMR"};